// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 51) return "unused_mock-data.js";
	if (chunkId === 856) return "unused_faker.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"98":"d4572df3d831ddf0","349":"d8eedec907d5603f","495":"e96e02e909172074","757":"26244f1d3fc2e37e","929":"a5ae3edbfa893779"}[chunkId] + ".js";
};